import { baseApi } from "@/core/api/baseApi";
import type {
  Appointment,
  AppointmentsListResponseDTO,
  AppointmentItemDTO,
  GetAppointmentsParams,
  ColumnType,
} from "../../domain/entities/Appointment";

const STAGE_MAP: Record<string, ColumnType> = {
  SCREENING: "Screening",
  SCR: "Screening",
  CLINICAL_CONTEXT: "Clinical Examination",
  CC: "Clinical Examination",
  REPORT_REVIEW: "Report Review",
  RR: "Report Review",
};

function mapItem(item: AppointmentItemDTO): Appointment {
  const { patient, assessment } = item;
  const doctor = assessment.doctors?.[0];
  return {
    id: assessment.id,
    patientId: patient.id,
    patientName: patient.name,
    patientPhone: patient.phone,
    column: STAGE_MAP[assessment.stage] ?? "Clinical Examination",
    status: assessment.status,
    scheduledStartAt: assessment.scheduled_start_at,
    scheduledEndAt: assessment.scheduled_end_at,
    doctor: doctor
      ? { userId: doctor.id, name: doctor.name, designation: doctor.designation }
      : { userId: "", name: "Unassigned", designation: "" },
  };
}

const appointmentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppointments: builder.query<Appointment[], GetAppointmentsParams>({
      query: ({ schedule_date, assigned_doctor_user_ids, search }) => ({
        url: `/patients/appointments`,
        params: {
          schedule_date,
          ...(search ? { search } : {}),
          ...(assigned_doctor_user_ids?.length
            ? { assigned_doctor_user_ids }
            : {}),
        },
      }),
      transformResponse: (response: AppointmentsListResponseDTO): Appointment[] => {
        console.log("[appointments] raw response:", JSON.stringify(response).slice(0, 300));
        const items = response?.data?.items;
        if (!Array.isArray(items)) return [];
        return items.map(mapItem);
      },
    }),
  }),
});

export const { useGetAppointmentsQuery } = appointmentsApi;
